import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ReactComponent as Disappointed } from '../../../assets/designSystem/icons/firstAid/wrong.svg';
import AdventureCard from '../../../components/AdventureCard';
import CustomButton from '../../../components/CustomButton';
import '../firstaid.css';

export default function Wrong({ setStep, setChoice, totalSteps = 7 }) {
  const { t } = useTranslation();

  const triggerNextStep = () => {
    setStep((prevStep) => {
      const isLastStep = prevStep === totalSteps;
      setChoice(isLastStep ? 'Finish' : '');
      return isLastStep ? 1 : prevStep + 1;
    });
  };

  return (
    <div className="wrong__container">
      <div className="header">
        <Disappointed className="correct__banner" />
        <AdventureCard text={t('staticPages.firstAidChild.tryAgain')} />
      </div>
      <div className="buttons__container">
        <CustomButton
          label={t('staticPages.firstAidChild.retryButton')}
          className="button__next"
          onClick={() => setChoice('')}
        />
        <CustomButton
          label={t('staticPages.firstAidChild.skipButton')}
          className="button__skip"
          onClick={triggerNextStep}
        />
      </div>
    </div>
  );
}

Wrong.propTypes = {
  setStep: PropTypes.func.isRequired,
  setChoice: PropTypes.func.isRequired,
};
